import React from "react";
import Spkapexcharts from "./spk-apexcharts";

const OverallStatisticsCard = ({ Graphoptions, DailyStats, DailyStatsPercentage}) => (
  <div className="card custom-card overflow-hidden">
    <div className="card-header pb-0 d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">Overall Statistics - {new Date().toLocaleString('default', { month: 'long' })}</h5>

    </div>
    <div className="card-body">
      <ul className="list-group activity-feed">
        {DailyStats.map((idx) => (
          <li className="list-group-item" key={Math.random()}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="lh-1">
                <p className="mb-2 fs-13 text-muted">{`Total ${idx.name}`}</p>
                {(() => {
                  const stat = DailyStatsPercentage.find(
                    (s) => s.name.replace(/^Total /, '') === idx.name.replace(/^Total /, '')
                  );
                  const iconClass = stat?.icon === 'up' ? 'bi bi-graph-up' : 'bi bi-graph-down';
                  const percentClass = stat?.icon === 'up' ? 'text-success' : 'text-danger';
                  return (
                    <h6 className="fw-medium mb-0">
                      {stat ? stat.total : '-'}
                      <span className={`fs-12 ${percentClass} ms-2 fw-normal d-inline-block`}>
                        {stat ? stat.percent + '%' : '-'}
                        <i className={`${iconClass} ms-1`}></i>
                      </span>
                    </h6>
                  );
                })()}
              </div>
              <div className="text-end">
                <div id="line-graph1" style={{ width: 100, height: 30 }}>
                  <Spkapexcharts chartOptions={Graphoptions} chartSeries={[idx]} type="line" width={100} height={30} />
                </div>
                <a href="#" className="fs-12">
                  <span>See more</span>
                  <span className="table-icon">
                    <i className="ms-1 d-inline-block bi bi-arrow-right"></i>
                  </span>
                </a>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default OverallStatisticsCard;
